import React from "react";
import Navbar from "./UI/Navbar";
import Index from "./Sections/index";
import SideMenu from "./UI/SideMenu";

function App() {
  return (
    <>
      <SideMenu />
      <Navbar />
      <Index />
    </>
  );
}

export default App;
